angular.module('impactx.purchaserequest').controller('TemplateCtrl', [
    '$mdDialog',
    '$scope',
    'ToastService',
    'dataGen',
    'items',
    'entryPoint',
    TemplateCtrl
]);

function TemplateCtrl($mdDialog, $scope, ToastService, dataGen, items, entryPoint){
    var self = this;

    dataGen.postAsForm($scope, {items:items}, entryPoint).then(function (){

    })


    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.ok = function () {
        $mdDialog.hide($scope.data.name.value);
    };
}
